import agents from 'collections/agentsInstance'
import fetchOncePromise from 'libraries/fetchOncePromise'

export default fetchOncePromise(agents);
